import angular from 'angular';

const interceptorModule = angular.module('tinaba.interceptors.http', [])

.factory('HttpLoadingInterceptor', ($q, $translate, FoundationApi, LoaderService, ValidazioneService) => {
  'ngInject';

  const getErrorMessage = key => {
    let message = ValidazioneService.getErrorMessage(key);
    if (message === undefined) {
      message = $translate.instant('common.errors.generic');
    }
    return message;
  };

  const interceptor = {
    request: (config) => {
      if (!config.isBackground) {
        LoaderService.addCall();
      }

      return config || $q.when(config);
    },
    response: (response) => {
      const isBackground = response.config !== undefined ? response.config.isBackground : false;
      if (isBackground === undefined || isBackground === false) {
        LoaderService.removeCall();
      }
      return response || $q.when(response);
    },
    responseError: (response) => {
      const isBackground = response.config !== undefined ? response.config.isBackground : false;
      if (isBackground === undefined || isBackground === false) {
        LoaderService.removeCall();
      }

      if (!response.config.customErrorManagement && response.status !== 401) { // authentication errors are already handled by angular-http-auth interceptor module
        if ('data' in response && angular.isObject(response.data)) {
          if ('errorCode' in response.data) {
            ValidazioneService.addBackEndError(response.data.errorCode);
          } else {
            ValidazioneService.addCustomError(getErrorMessage(response.status));
          }
        } else {
          ValidazioneService.addCustomError(getErrorMessage(response.status));
        }
      }

      return $q.reject(response);
    }
  };

  return interceptor;
})

.config(($httpProvider) => {
  'ngInject';
  $httpProvider.interceptors.push('HttpLoadingInterceptor');
});

export default interceptorModule;



/** WEBPACK FOOTER **
 ** ./client/app/common/interceptors/http.interceptor.js
 **/